import React, { useEffect } from "react";
import Footer from "../utilities/Footer";
import AppState from "../../util/AppState";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import calculateHMACToken from "../../util/calculateHMACToken";
import { logFunctions as log } from "../../util/Logging";
import { v4 as uuid_v4 } from "uuid";

function LoadingScreen(props) {
  log.debug("+LoadingScreen(TRACE)");

  const { t } = useTranslation("translation");

  useEffect(() => {
    log.debug("+LoadingScreen_useEffect(TRACE)");
    if (props.state === AppState.LOADING_SCREEN) {
      setTimeout(() => {
        log.info("LoadingScreen_useEffect() => transition to: SelectIDScreen");
        transitionToSelectIDScreen();
      }, 2000);
    } else if (props.state === AppState.CONFIGURING_SCREEN) {
      setTimeout(function () {
        log.info("LoadingScreen_useEffect() => transition to: AttractScreen");
        checkValuesInLocalStorage();
      }, 2000);
    }
    log.debug("-LoadingScreen_useEffect(TRACE)");
  });

  const transitionToSelectIDScreen = () => {
    log.debug("+LoadingScreen_transitionToSelectIDScreen(TRACE)");
    var org = localStorage.getItem("orgID");
    var stylesheetURL = localStorage.getItem("StyleSheetURL");
    var supportedLocales = localStorage.getItem("SupportedLocales");
    var sharedKey = localStorage.getItem("SharedKey");
    var secretKey = localStorage.getItem("SecretKey");

    if (org && stylesheetURL && supportedLocales && sharedKey && secretKey) {
      log.info("LoadingScreen_transitionToSelectIDScreen() => updating state");
      const date = new Date();
      const dateForAuth = date.toISOString().slice(0, 19) + ".000Z";
      const correlation_id = uuid_v4();
      const secretKey = window.atob(localStorage.getItem("SecretKey"));

      const hmacToken = calculateHMACToken(
        secretKey,
        sharedKey,
        org,
        dateForAuth,
        "POST",
        "/site/sites/find-by-criteria",
        correlation_id
      );

      axios({
        method: "post",
        url: window.SCANNERWALLPROXYURL + "/site/sites/find-by-criteria",
        withCredentials: false,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "nep-organization": org,
          "nep-correlation-id": correlation_id,
          "Date-Header": date.toGMTString(),
          Authorization: hmacToken,
        },
        data: {},
      })
        .then((response) => {
          log.info(
            "LoadingScreen_transitionToSelectIDScreen() => Nep correlation Id: " +
              correlation_id +
              ". The response for find sites is: " +
              JSON.stringify(response.data)
          );
          props.transitionToSelectIDScreen(response.data.pageContent);
        })
        .catch((error) => {
          log.error(
            "LoadingScreen_transitionToSelectIDScreen() => Error during retreive from site service: %s",
            error.message
          );
          log.debug("-LoadingScreen_transitionToSelectIDScreen(TRACE)");
          props.transitionToErrorStagingScreen();
        });
    } else {
      log.debug("-LoadingScreen_transitionToSelectIDScreen(TRACE)");
      props.transitionToErrorStagingScreen();
    }
  };

  const checkValuesInLocalStorage = () => {
    log.debug("+LoadingScreen_checkValuesInLocalStorage(TRACE)");
    var org = localStorage.getItem("orgID");
    var stylesheetURL = localStorage.getItem("StyleSheetURL");
    var supportedLocales = localStorage.getItem("SupportedLocales");
    var sharedKey = localStorage.getItem("SharedKey");
    var secretKey = localStorage.getItem("SecretKey");
    var site = localStorage.getItem("siteID");
    var wallID = localStorage.getItem("wallID");

    if (
      org &&
      stylesheetURL &&
      supportedLocales &&
      sharedKey &&
      secretKey &&
      site &&
      wallID
    ) {
      log.debug("-LoadingScreen_checkValuesInLocalStorage(TRACE)");
      props.transitionToConfiguringSuccessScreen();
    } else {
      log.debug("-LoadingScreen_checkValuesInLocalStorage(TRACE)");
      props.transitionToErrorStagingScreen();
    }
  };

  const renderMessage = () => {
    if (props.state === AppState.LOADING_SCREEN) {
      return <p id="loadingLabel">{t("Loading configuration")}</p>;
    } else if (props.state === AppState.CONFIGURING_SCREEN) {
      return (
        <p id="loadingLabel">
          {t("Please wait Loading location and ID profile")}
        </p>
      );
    }
  };

  log.debug("-LoadingScreen(TRACE)");
  return (
    <div className="Screen">
      <div className="contentContainer">
        <div className="loadingTextBox">
          <div className="loaderIcon" id="loaderIcon">
            <CircularProgress size={"100px"} id="circularProgressIcon" />
          </div>
          {renderMessage()}
        </div>
      </div>
      <div className="footerContainer" id="footer">
        <Footer
          transitionToSelectLanguageScreen={
            props.transitionToSelectLanguageScreen
          }
          state={AppState.LOADING_SCREEN}
        />
      </div>
    </div>
  );
}

export default LoadingScreen;
